/* =====================================================================
   SH4DE — scripts des pages : hero vidéo, popup, à propos, produit
   ===================================================================== */
(function () {
  'use strict';
  var doc = document, html = doc.documentElement;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LS = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  /* ------------------------------------------------------------------
     HERO VIDÉO : lecture auto, ruban 3D en secours si la vidéo échoue
  ------------------------------------------------------------------ */
  function heroVideo() {
    // La vidéo est optionnelle : sans réglage vidéo, cet élément n'existe pas
    // et l'animation de fond (heroBackground, dans sh4de-kairo.js) reste seule visible.
    var v = $('[data-kr-hero-video]'); if (!v) return;
    var hero = v.closest('.kr-hero'), done = false;
    function fallback() { done = true; } // l'animation de fond, déjà visible dessous, prend le relais
    function ok() { done = true; v.classList.add('is-playing'); }
    var src = $('source', v);
    if (src) src.addEventListener('error', fallback);
    v.addEventListener('error', fallback);
    v.addEventListener('playing', ok);
    v.addEventListener('loadeddata', function () { if (v.readyState >= 2) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } });
    var p = v.play(); if (p && p.catch) p.catch(function () {});
    setTimeout(function () { if (!done && v.paused && v.readyState < 2) fallback(); }, 5000);
    if (reduce) { v.pause(); v.classList.add('is-playing'); }
    if ('IntersectionObserver' in window && !reduce) {
      new IntersectionObserver(function (es) {
        if (!done && !v.classList.contains('is-playing')) return;
        if (es[0].isIntersecting) { var q = v.play(); if (q && q.catch) q.catch(function () {}); } else v.pause();
      }).observe(hero);
    }
  }

  /* ------------------------------------------------------------------
     POPUP INSCRIPTION −5 %
  ------------------------------------------------------------------ */
  function popup() {
    var pop = $('[data-kr-pop]'); if (!pop) return;
    var code = pop.getAttribute('data-code') || '';
    var delay = (parseInt(pop.getAttribute('data-delay'), 10) || 8) * 1000;
    var formWrap = $('[data-pop-form-wrap]', pop), done = $('[data-pop-done]', pop);
    var form = $('form', pop), err = $('[data-pop-err]', pop), btn = $('.kr-pop__btn', form);
    var opened = false, lastFocus = null;

    function isBlocked() {
      var b = doc.body.className;
      return /template-cart|template-password/.test(b) || html.classList.contains('kr-intro');
    }
    function open(force) {
      if (opened) return;
      if (!force && (isBlocked() || LS.get('kr-nl'))) return;
      opened = true; lastFocus = doc.activeElement;
      pop.classList.add('is-open'); pop.setAttribute('aria-hidden', 'false');
      LS.set('kr-pop-seen', String(Date.now()));
      setTimeout(function () { var i = $('input[type=email]', pop); if (i && !formWrap.hidden) i.focus({ preventScroll: true }); }, 700);
    }
    function close() {
      opened = false; pop.classList.remove('is-open'); pop.setAttribute('aria-hidden', 'true');
      LS.set('kr-pop-seen', String(Date.now()));
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    function applyDiscount() {
      if (!code) return Promise.resolve();
      return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
    }
    function showDone() {
      formWrap.hidden = true; done.hidden = false;
      var b = $('[data-pop-code]', done); if (b) b.textContent = code;
      markSubscribed();
    }
    function markSubscribed() {
      LS.set('kr-nl', code || '1');
      $$('[data-nl-off]').forEach(function (e) { e.hidden = true; });
      $$('[data-nl-on]').forEach(function (e) { e.hidden = false; });
    }

    $$('[data-pop-close]', pop).forEach(function (b) { b.addEventListener('click', close); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && opened) close(); });
    doc.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-kr-open-popup]');
      if (!t) return;
      e.preventDefault();
      if (LS.get('kr-nl')) { formWrap.hidden = true; done.hidden = false; var c = $('[data-pop-code]', done); if (c) c.textContent = LS.get('kr-nl') === '1' ? code : LS.get('kr-nl'); }
      open(true);
    });

    var copy = $('[data-pop-copy]', pop);
    if (copy) copy.addEventListener('click', function () {
      var lbl = $('[data-pop-copy-lbl]', pop);
      var T = window.SH4DE_T || function (k, d) { return d; };
      var ok = function () { lbl.textContent = T('copied', 'Copié ✓'); setTimeout(function () { lbl.textContent = T('copy', 'Copier'); }, 1800); };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(ok, ok); else ok();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      err.hidden = true; btn.classList.add('is-load');
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
        .then(function (r) {
          // Shopify redirige vers ?customer_posted=true quand l'inscription est acceptée
          var success = r.ok && (r.redirected || /customer_posted=true/.test(r.url));
          if (!success) throw new Error('invalid');
          return applyDiscount().then(showDone);
        })
        .catch(function () { err.hidden = false; })
        .then(function () { btn.classList.remove('is-load'); });
    });

    if (LS.get('kr-nl')) markSubscribed();
    var seen = parseInt(LS.get('kr-pop-seen') || '0', 10);
    var recently = seen && (Date.now() - seen) < 7 * 24 * 3600 * 1000;
    var forced = /[?&]kr-popup=1/.test(location.search);
    if (forced) { setTimeout(function () { open(true); }, 600); return; }
    if (recently || LS.get('kr-nl')) return;

    // Sur une page produit, on ne dérange pas l'achat : seulement à l'intention de départ (desktop)
    var onProduct = /template-product/.test(doc.body.className);
    var timer = onProduct ? null : setTimeout(function () { open(false); }, delay);
    var scrolled = false;
    if (!onProduct) window.addEventListener('scroll', function () {
      if (scrolled) return;
      var p = window.scrollY / Math.max(1, doc.documentElement.scrollHeight - window.innerHeight);
      if (p > .45 && window.scrollY > 600) { scrolled = true; clearTimeout(timer); setTimeout(function () { open(false); }, 900); }
    }, { passive: true });
    if (window.matchMedia('(hover:hover)').matches) {
      doc.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY < 8 && performance.now() > 12000) open(false);
      });
    }
  }

  /* ------------------------------------------------------------------
     À PROPOS
  ------------------------------------------------------------------ */
  function about() {
    // hero : logo qui suit la souris
    var hero = $('[data-kr-ab-hero]');
    if (hero && !reduce && window.matchMedia('(hover:hover)').matches) {
      var lg = $('[data-ab-logo]', hero);
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        lg.style.setProperty('--px', (x * -50) + 'px'); lg.style.setProperty('--py', (y * -40) + 'px'); lg.style.setProperty('--rot', (x * 4) + 'deg');
      });
    }

    // promesses : accordéon + photo synchronisée
    var prom = $('[data-kr-prom]');
    if (prom) {
      var rows = $$('[data-prom-row]', prom), imgs = $$('[data-prom-img]', prom), cur = 0, t;
      var set = function (i) {
        cur = i;
        rows.forEach(function (r, k) { r.classList.toggle('is-on', k === i); $('button', r).setAttribute('aria-expanded', k === i ? 'true' : 'false'); });
        imgs.forEach(function (m, k) { m.classList.toggle('is-on', k === i); });
      };
      rows.forEach(function (r, i) {
        $('button', r).addEventListener('click', function () { set(i); });
        if (window.matchMedia('(hover:hover)').matches) {
          r.addEventListener('mouseenter', function () { clearTimeout(t); t = setTimeout(function () { set(i); }, 120); });
          r.addEventListener('mouseleave', function () { clearTimeout(t); });
        }
      });
    }

    // anatomie : points interactifs
    var anat = $('[data-kr-anat]');
    if (anat) {
      var hots = $$('[data-hot]', anat), items = $$('[data-hot-item]', anat);
      var setHot = function (i) {
        hots.forEach(function (o, k) { o.classList.toggle('is-open', k === i); });
        items.forEach(function (o, k) { o.classList.toggle('is-on', k === i); });
      };
      items.forEach(function (it, i) {
        it.addEventListener('click', function () { setHot(i); });
        if (window.matchMedia('(hover:hover)').matches) it.addEventListener('mouseenter', function () { setHot(i); });
      });
      setHot(0);
      hots.forEach(function (h, i) {
        h.addEventListener('click', function (e) { e.stopPropagation(); setHot(i); });
      });
    }

    // galerie à glisser (inertie)
    $$('[data-kr-drag]').forEach(function (box) {
      var track = $('.kr-ab-drag__track', box), x = 0, vx = 0, drag = null, max = 0, raf = 0, moved = false;
      var measure = function () { max = Math.max(0, track.scrollWidth - box.clientWidth); };
      measure(); window.addEventListener('resize', measure); window.addEventListener('load', measure);
      var apply = function () { x = clamp(x, -max, 0); track.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)'; };
      var inertia = function () {
        if (drag) return;
        x += vx; vx *= .94; apply();
        if (Math.abs(vx) > .3 && x > -max && x < 0) raf = requestAnimationFrame(inertia);
      };
      box.addEventListener('pointerdown', function (e) { cancelAnimationFrame(raf); drag = { x: e.clientX, s: x, lx: e.clientX }; vx = 0; box.classList.add('is-drag'); });
      window.addEventListener('pointermove', function (e) {
        if (!drag) return;
        vx = e.clientX - drag.lx; drag.lx = e.clientX;
        x = drag.s + (e.clientX - drag.x); apply();
        if (!moved && Math.abs(e.clientX - drag.x) > 6) { moved = true; box.classList.add('is-moved'); }
      });
      window.addEventListener('pointerup', function () { if (!drag) return; drag = null; box.classList.remove('is-drag'); inertia(); });
      box.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) { e.preventDefault(); x -= e.deltaX; apply(); box.classList.add('is-moved'); }
      }, { passive: false });
    });
  }


  /* ------------------------------------------------------------------
     À PROPOS v2 : projecteur, chapitres horizontaux, cartes
  ------------------------------------------------------------------ */
  function about2() {
    // 1. projecteur qui suit la souris (mouvement automatique sur mobile)
    var hero = $('[data-a2-hero]');
    if (hero) {
      var fr = $('[data-a2-frame]', hero), hasHover = window.matchMedia('(hover:hover)').matches;
      var mx = 50, my = 50, tx = 50, ty = 50, r = 90, tr = 150, auto = true, t = 0, vis = true;
      fr.addEventListener('pointermove', function (e) {
        var b = fr.getBoundingClientRect();
        tx = (e.clientX - b.left) / b.width * 100; ty = (e.clientY - b.top) / b.height * 100;
        tr = Math.max(150, b.width * .3); auto = false; fr.classList.add('is-used');
      });
      fr.addEventListener('pointerleave', function () { auto = true; });
      if (reduce) { fr.style.setProperty('--r', '260px'); }
      else {
        if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { vis = es[0].isIntersecting; }).observe(fr);
        var hint = $('[data-a2-hint]', fr); if (hint && !hasHover) hint.textContent = 'Touche l\'image';
        (function loop() {
          if (vis) {
            if (auto) { t += .009; tx = 50 + 30 * Math.sin(t * 1.3); ty = 50 + 26 * Math.cos(t * .9); tr = Math.max(140, fr.clientWidth * .28); }
            mx += (tx - mx) * .09; my += (ty - my) * .09; r += (tr - r) * .08;
            fr.style.setProperty('--mx', mx.toFixed(2) + '%'); fr.style.setProperty('--my', my.toFixed(2) + '%'); fr.style.setProperty('--r', r.toFixed(1) + 'px');
          }
          requestAnimationFrame(loop);
        })();
      }
    }

    // 2. chapitres : défilement horizontal épinglé
    var sec = $('[data-a2-h]');
    if (sec) {
      var track = $('[data-a2-track]', sec), figs = $$('[data-a2-fig]', sec), bar = $('[data-a2-bar]', sec), cur = $('[data-a2-cur]', sec);
      var n = figs.length, mq = window.matchMedia('(min-width:901px)'), on = false, maxX = 0, tick = false;
      var update = function () {
        if (!on) return;
        var rc = sec.getBoundingClientRect();
        var p = clamp(-rc.top / Math.max(1, sec.offsetHeight - window.innerHeight), 0, 1);
        track.style.transform = 'translate3d(' + (-p * maxX).toFixed(1) + 'px,0,0)';
        bar.style.setProperty('--f', p.toFixed(4));
        var i = Math.min(n - 1, Math.round(p * (n - 1)));
        cur.textContent = '0' + (i + 1);
        figs.forEach(function (f) {
          var b = f.getBoundingClientRect();
          var off = ((b.left + b.width / 2) - window.innerWidth / 2) * -.04;
          f.style.setProperty('--sx', off.toFixed(1) + 'px');
        });
      };
      var measure = function () {
        on = mq.matches;
        if (!on) { sec.style.height = ''; track.style.transform = ''; return; }
        maxX = Math.max(0, track.scrollWidth - window.innerWidth);
        sec.style.height = (maxX + window.innerHeight) + 'px';
        update();
      };
      measure();
      window.addEventListener('resize', measure); window.addEventListener('load', measure);
      if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(measure);
      window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(function () { update(); tick = false; }); } }, { passive: true });
    }

    // 3. promesses : cartes qui s'élargissent
    var cards = $$('[data-a2-card]');
    if (cards.length) {
      var setCard = function (c) { cards.forEach(function (o) { o.classList.toggle('is-on', o === c); }); };
      cards.forEach(function (c) {
        c.addEventListener('click', function () { setCard(c); });
        c.addEventListener('focus', function () { setCard(c); });
        c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setCard(c); } });
        if (window.matchMedia('(hover:hover) and (min-width:901px)').matches) c.addEventListener('mouseenter', function () { setCard(c); });
      });
    }
  }

  /* ------------------------------------------------------------------
     PAGE PRODUIT : galerie, tailles, achat immédiat
  ------------------------------------------------------------------ */
  function product() {
    var root = $('[data-kr-pdp]'); if (!root) return;
    var data = {}; try { data = JSON.parse($('[data-kr-pdp-data]', root).textContent); } catch (e) { return; }
    var cur = (root.getAttribute('data-currency') || 'EUR');
    var money = function (c) { try { return (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: cur, minimumFractionDigits: 2 }); } catch (e) { return (c / 100).toFixed(2) + ' €'; } };

    /* --- galerie --- */
    var slider = $('[data-slider]', root), slides = $$('[data-slide]', root), thumbs = $$('[data-thumb]', root), cnt = $('[data-cur]', root);
    var idx = 0;
    function go(i) {
      idx = clamp(i, 0, slides.length - 1);
      slider.scrollTo({ left: slider.clientWidth * idx, behavior: reduce ? 'auto' : 'smooth' });
    }
    function mark() {
      var i = Math.round(slider.scrollLeft / Math.max(1, slider.clientWidth));
      if (i === idx && thumbs[i] && thumbs[i].classList.contains('is-on')) return;
      idx = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      if (cnt) cnt.textContent = i + 1;
      var t = thumbs[i]; if (t && t.parentNode) t.parentNode.scrollTo({ left: t.offsetLeft - 20, behavior: 'smooth' });
    }
    if (slider) slider.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    var pv = $('[data-prev]', root), nx = $('[data-next]', root);
    if (pv) pv.addEventListener('click', function () { go((idx - 1 + slides.length) % slides.length); });
    if (nx) nx.addEventListener('click', function () { go((idx + 1) % slides.length); });

    /* --- zoom --- */
    var lbx = $('[data-lbx]', root), lbxImg = $('[data-lbx-img]', root);
    slides.forEach(function (s) {
      s.addEventListener('click', function () {
        var im = $('img', s); lbxImg.src = im.getAttribute('data-zoom') || im.src; lbx.hidden = false;
      });
    });
    var closeLbx = function () { lbx.hidden = true; lbxImg.removeAttribute('src'); };
    lbx.addEventListener('click', closeLbx);
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lbx.hidden) closeLbx(); });

    /* --- achat --- */
    var form = $('[data-kr-buy]', root); if (!form) return;
    var vid = $('[data-vid]', form), q = $('[data-q]', form), qv = $('[data-q-val]', form);
    var sizes = $$('.kr-sz', form), sizeBox = $('[data-sizes]', form), sizeH = $('.kr-pdp__sizes-h', form), pick = $('[data-size-pick]', form);
    var priceEl = $('[data-price]', root), cmp = $('[data-compare]', root), buyPrice = $('[data-buy-price]', root), buyLabel = $('[data-buy-label]', root);
    var stock = $('[data-stock]', root), err = $('[data-err]', form), buyBtn = $('[data-act=buy]', form), addBtn = $('[data-act=add]', form);
    var bar = $('[data-bar]', root), barPrice = $('[data-bar-price]', root), barLabel = $('[data-bar-label]', root), barBtn = $('[data-bar-buy]', root);
    var multi = !!data.multi, sel = null, qty = 1;

    function variantById(id) { return data.variants.filter(function (v) { return String(v.id) === String(id); })[0]; }
    if (!multi) sel = data.variants[0];

    function refresh() {
      var unit = sel ? sel.price : Math.min.apply(null, data.variants.map(function (v) { return v.price; }));
      priceEl.textContent = money(unit);
      if (cmp) { if (sel && sel.compare > sel.price) { cmp.textContent = money(sel.compare); cmp.hidden = false; } else cmp.hidden = true; }
      var total = unit * qty;
      buyPrice.textContent = money(total);
      barPrice.textContent = money(total);
      qv.textContent = qty; q.value = qty;
      var need = multi && !sel;
      buyLabel.textContent = need ? 'Choisir ma taille' : 'Acheter maintenant';
      barLabel.textContent = need ? 'Choisir ma taille' : 'Acheter maintenant';
      buyBtn.classList.toggle('is-ready', !need);
      buyPrice.hidden = need;
      vid.value = sel ? sel.id : '';
      pick.textContent = sel ? 'Taille ' + sel.title : 'Choisis ta taille';
      // stock faible (uniquement si le stock est suivi par Shopify)
      var el = sizes.filter(function (b) { return sel && String(b.getAttribute('data-vid')) === String(sel.id); })[0];
      var left = el ? parseInt(el.getAttribute('data-qty'), 10) : -1;
      if (left > 0 && left <= 8) { stock.textContent = 'Plus que ' + left + ' en stock'; stock.hidden = false; } else stock.hidden = true;
      // URL partageable
      if (sel && multi && window.history && history.replaceState) { try { history.replaceState(null, '', '?variant=' + sel.id); } catch (e) {} }
    }
    sizes.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        sel = variantById(b.getAttribute('data-vid'));
        sizes.forEach(function (o) { o.setAttribute('aria-checked', o === b ? 'true' : 'false'); });
        sizeH.classList.remove('is-alert'); err.hidden = true;
        refresh();
      });
    });
    var qm = $('[data-q-minus]', form), qp = $('[data-q-plus]', form);
    qm.addEventListener('click', function () { qty = Math.max(1, qty - 1); refresh(); });
    qp.addEventListener('click', function () { qty = Math.min(10, qty + 1); refresh(); });

    // présélection ?variant=
    var mv = /[?&]variant=(\d+)/.exec(location.search);
    if (mv && multi) { var b0 = sizes.filter(function (b) { return b.getAttribute('data-vid') === mv[1] && !b.disabled; })[0]; if (b0) b0.click(); }

    function needSize() {
      sizeH.classList.add('is-alert'); pick.textContent = 'Choisis une taille pour continuer';
      sizeBox.classList.remove('is-shake'); void sizeBox.offsetWidth; sizeBox.classList.add('is-shake');
      if (window.innerWidth < 1000) sizeBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    function fail(msg) { err.textContent = msg || 'Impossible d\'ajouter cette pièce. Réessaie dans un instant.'; err.hidden = false; }
    function setCount(n) { $$('[data-kr-count]').forEach(function (b) { b.textContent = n; b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); }); }

    function submit(buy) {
      err.hidden = true;
      if (multi && !sel) { needSize(); return; }
      var btn = buy ? buyBtn : addBtn, old = btn.innerHTML;
      btn.classList.add('is-load'); if (buy) buyLabel.textContent = 'Redirection…'; else btn.textContent = 'Ajout…';
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: sel.id, quantity: qty }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          if (buy) {
            var c = LS.get('kr-nl');
            location.href = (window.SH4DE_ROOT || '/') + 'checkout' + (c && c !== '1' ? '?discount=' + encodeURIComponent(c) : '');
            return;
          }
          btn.classList.remove('is-load'); btn.classList.add('is-done'); btn.textContent = 'Ajouté ✓';
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            setCount(c.item_count);
            if (typeof window.renderCartToDrawer === 'function') window.renderCartToDrawer(c);
            if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
          });
          setTimeout(function () { btn.classList.remove('is-done'); btn.innerHTML = old; }, 2200);
        })
        .catch(function (e) {
          btn.classList.remove('is-load'); btn.innerHTML = old; refresh();
          fail(e && (e.description || e.message));
        });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var s = e.submitter; submit(!!(s && s.name === 'checkout'));
    });
    if (barBtn) barBtn.addEventListener('click', function () { submit(true); });

    // barre collante mobile
    if (bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var e = es[0], below = e.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', !e.isIntersecting && below);
      }, { threshold: 0 }).observe($('.kr-pdp__cta', form));
    }
    refresh();
  }

  function boot() { heroVideo(); popup(); about(); about2(); product(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();
